import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logoImg from '../assets/generated/logo-mark.png';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const whatsappUrl = 'https://api.whatsapp.com/send/?phone=919022040062&text=Hello%20i-Sha%20Infosys';

  function closeMenu() {
    setMobileMenuOpen(false);
  }

  return (
    <header className="site-header">
      <div className="container header-inner">
        <Link to="/" className="brand-link" onClick={closeMenu}>
          <img src={logoImg} alt="i-Sha Infosys" className="logo" />
          <div className="brand-text">
            <span className="brand-name">i-Sha Infosys</span>
            <span className="brand-tag">Modern business IT infrastructure and support</span>
          </div>
        </Link>

        <nav className={`nav ${mobileMenuOpen ? 'nav-mobile-open' : ''}`}>
          <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
            Home
          </NavLink>
          <NavLink to="/services" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
            Services
          </NavLink>
          <NavLink to="/contact" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
            Contact
          </NavLink>
          <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-accent">
            WhatsApp
          </a>
        </nav>

        <button
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'is-open' : ''}`}
          onClick={() => setMobileMenuOpen((open) => !open)}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>
      </div>
    </header>
  );
}
